module.exports = __webpack_public_path__ + "static/media/ec.a80c5904.svg";